import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import logo from "@/assets/logo.png";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const showTagline = location.pathname === "/" || location.pathname === "/academy";

  const navLinks = [
    { label: "Home", href: "/" },
    { label: "About", href: "/about" },
    { label: "Real Estate", href: "/real-estate" },
    { label: "Mortgage", href: "/mortgage" },
    { label: "Speaking", href: "/speaking" },
    {
      label: "Fresh Vision Academy",
      href: "https://freshvisionacademy.org/",
      external: true,
    },
    { label: "Resources", href: "/academy/tools" },
  ];


  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#0D1B2A] border-b border-white/10">
      <div className="container mx-auto px-6">
        <div className="flex items-center h-[110px] md:h-[120px]">
          <Link to="/" className="flex-shrink-0 flex flex-col items-center justify-center mr-12 -my-4">
            <img src={logo} alt="Marquetta Bryant Logo" className="h-[110px] md:h-[130px] w-auto block -my-6" />
            {showTagline && (
              <span className="-mt-3 text-[0.65rem] md:text-[0.7rem] font-light uppercase tracking-[0.15em] text-[#C4A96A] leading-none whitespace-nowrap">Visionary for the Visionary.</span>
            )}
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8 flex-1">
            {navLinks.map((link) =>
              link.external ? (
                <a
                  key={link.label}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/90 hover:text-[#C5A059] transition-colors font-medium text-[13px] tracking-wide uppercase whitespace-nowrap"
                >
                  {link.label}
                </a>
              ) : (
                <Link
                  key={link.label}
                  to={link.href}
                  className="text-white/90 hover:text-[#C5A059] transition-colors font-medium text-[13px] tracking-wide uppercase whitespace-nowrap"
                >
                  {link.label}
                </Link>
              )
            )}
            <a href="https://marquettas-newsletter.beehiiv.com/" target="_blank" rel="noopener noreferrer" className="ml-auto">
              <Button className="bg-[#C5A059] text-[#0D1B2A] hover:bg-[#D4AF6A] font-semibold text-[13px] tracking-wide rounded-lg px-6 h-11 hover:scale-105 transition-all duration-300 shadow-lg whitespace-nowrap">
                Get Weekly Intel
              </Button>
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-white"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden py-6 flex flex-col gap-5 border-t border-white/10">
            {navLinks.map((link) =>
              link.external ? (
                <a
                  key={link.label}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setIsMenuOpen(false)}
                  className="text-white/90 hover:text-[#C5A059] transition-colors font-medium text-[16px] tracking-wide uppercase"
                >
                  {link.label}
                </a>
              ) : (
                <Link
                  key={link.label}
                  to={link.href}
                  onClick={() => setIsMenuOpen(false)}
                  className="text-white/90 hover:text-[#C5A059] transition-colors font-medium text-[16px] tracking-wide uppercase"
                >
                  {link.label}
                </Link>
              )
            )}
            <a href="https://marquettas-newsletter.beehiiv.com/" target="_blank" rel="noopener noreferrer" onClick={() => setIsMenuOpen(false)}>
              <Button className="w-full bg-[#C5A059] text-[#0D1B2A] hover:bg-[#D4AF6A] font-semibold text-[15px] tracking-wide rounded-lg h-12">
                Get Weekly Intel
              </Button>
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
